import React from 'react'

const ItemForm = props => {
    //set form state variables

    //handle submit
        //fetch call to post program variables to database
        //set show create form variable to false
    

    return (
        <div>Item form STUB</div>
    )
}

export default ItemForm